module.exports = __webpack_public_path__ + "media/images/cleaning/card-mobile@3x-f31a5c869d16df0c09b6aca1374165bd.jpg";